import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/layout/Layout'
import ProtectedRoute from './components/auth/ProtectedRoute'
import LandingPage from './pages/LandingPage'
import HomePage from './pages/HomePage'
import LoginPage from './pages/LoginPage'
import WorkspacePageV2 from './pages/WorkspacePageV2'
import PublishedProjectPage from './pages/PublishedProjectPage'
import DevDashboardPage from './pages/DevDashboardPage'
import ForAgentsPage from './pages/ForAgentsPage'
import StyleLibraryTestPage from './pages/StyleLibraryTestPage'

/** Redirect old /shared/:token URLs — these no longer work without a version slug */
function SharedRedirect() {
  return <Navigate to="/" replace />
}

export default function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/landing" element={<LandingPage />} />
      <Route path="/for-agents" element={<ForAgentsPage />} />
      <Route path="/published/:projectToken/:versionSlug" element={<PublishedProjectPage />} />
      {/* Backward compat: old URLs without version slug */}
      <Route path="/shared/:shareToken" element={<SharedRedirect />} />
      {import.meta.env.DEV && <Route path="/dev/dashboard" element={<DevDashboardPage />} />}
      {import.meta.env.DEV && <Route path="/test/style-library" element={<StyleLibraryTestPage />} />}

      {/* Protected routes - require authentication */}
      <Route element={<ProtectedRoute />}>
        {/* Canvas V2 workspace route */}
        <Route path="/v2/project/:projectId/workspace" element={<WorkspacePageV2 />} />
        <Route path="/v2/project/:projectId/workspace/:canvasId" element={<WorkspacePageV2 />} />

        <Route element={<Layout />}>
          <Route path="dashboard" element={<HomePage />} />
        </Route>
      </Route>
    </Routes>
  )
}
